import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  dropdownMenu: {
    marginTop: "60px",
    "& .MuiPaper-root": {
      right: "30px",
      top: "152px!important",
      left: "auto!important",
    },
  },
  item: {
    padding: "12px 30px",
    fontFamily: "Inter",
    fontWeight: 500,
    "&.MuiListItem-button:hover": {
      backgroundColor: "#F1F7FF",
    },
    display: "flex",
    gap: "7px",
  },
});
